exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".landing {\n  color: white; }\n  .landing .app-stores {\n    color: white;\n    background-color: #00b0ff;\n    margin-bottom: 50px;\n    padding: 20px;\n    text-align: center;\n    font-size: 22px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap; }\n    .landing .app-stores .app-stores-message {\n      margin: 0 50px; }\n    .landing .app-stores .apple-tv img {\n      height: 55px; }\n    .landing .app-stores .google-play img {\n      width: 200px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/landing/landing.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/landing/landing.scss
// module chunks = index